<template>
  <div class="threeImageList">
    <div class="indexContainer">
      <el-divider class="indexTitle" v-if="val.title">
        <div class="indexTitleMain">
          <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br />
          <h4>{{val.summary}}</h4>
        </div>
      </el-divider>
      <div>
        <el-row :gutter="20">
          <el-col :xs="12" :sm="8" v-for="(item, index) in newList" :key="index">
            <div class="newList" @click="rowClick(item, index)">
              <div class="newListImg">
                <img :src="item.picUrl" :alt="item.imgAlt">
              </div>
              <p class="title">
                <span class="dateText">{{item.releaseTime|dateFormat}}</span>
                <span>
                  <b v-if="item.isNew == 1">NEW</b>
                  <b v-if="item.isHot == 1">HOT</b>
                </span>
                <span class="text">{{(item.modules && item.modules.length>0) ? item.modules[0].name : ''}}</span>
                <!-- <span class="text">{{val.title ? val.title : val.module.name}}</span> -->
              </p>
              <p class="text">{{item.title}}</p>
            </div>
          </el-col>
          <el-col :span="24" v-if="val.more = 1">
            <el-button class="more" round @click="handleShow">{{val.moreText}}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--视频弹窗-->
    <video-dialog ref="video" />
    <!--图片弹窗-->
    <pic-dialog ref="pic" />
  </div>
</template>
<script>
import { filterTime } from '@/common/js/common.js'
import VideoDialog from '@/components/common/components/videoDialog'
import PicDialog from '@/components/common/components/picDialog'
export default {
  components: {
    VideoDialog,
    PicDialog,
  },
  props: {
    val: {},
  },
  data() {
    return {
      newList: [],
      moduleId: '',
    }
  },
  created() {
    this.newList = []
    if (this.val.modules && this.val.modules.length > 0) {
      this.newList = this.val.modules[0].articles || []
    }
    this.moduleId = this.val.moduleId
  },
  methods: {
    handleShow() {
      let routerURL = this.$router.resolve({
        name: 'INNERPAGER',
        query: {
          model: this.val.module.model,
          id: this.val.module.id,
          moduleId: this.moduleId,
          level: 2,
          type: Number(this.val.module.model) === 1 ? 2 : 1,
          languageId: this.val.module.languageId,
        },
      })
      window.open(routerURL.href, '_blank')
    },
    rowClick(row, index) {
      if (row.isLink && row.linkUrl) {
        window.open(row.linkUrl, '_blank')
        return
      }
      if (Number(row.type) === 0) {
        let routerPath = this.$router.resolve({
          name: 'ARTICLEDETAIL',
          query: {
            languageId: this.$route.query.languageId,
            model: this.$route.query.model,
            moduleId: this.moduleId,
            modelId: this.$route.query.id,
            level: this.$route.query.level,
            type: this.$route.query.type,
            id: row.id,
          },
        })
        window.open(routerPath.href, '_blank')
      } else if (Number(row.type) === 1) {
        let item = this.handleData()
        this.$refs.pic.open(item, index)
      } else if (Number(row.type) === 2) {
        this.$refs.video.open(row)
      }
    },
    handleData() {
      let data = []
      for (let v of this.newList) {
        if (Number(v.type) === 1) {
          data.push(v)
        }
      }
      return data
    },
  },
  watch: {
    val(val) {
      this.newList = []
      if (this.val.modules && this.val.modules.length > 0) {
        this.newList = this.val.modules[0].articles || []
      }
    },
  },
}
</script>
<style lang="less" scoped>
.threeImageList {
  .newList {
    border-radius: 4px;
    background: #f7f7f7;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    margin-bottom: 10px;
    cursor: pointer;
    .newListImg {
      width: 100%;
      height: 102px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    p {
      line-height: 28px;
    }
    p.title {
      padding: 10px 10px 0;
      text-align: left;
      margin: 0;
      overflow: hidden; /*隐藏*/
      white-space: nowrap; /*不换行*/
      text-overflow: ellipsis; /* 超出部分省略号 */
      width: 100%;
      height: 36px;
      box-sizing: border-box;
      span {
        color: #d11a2e;
        font-size: 16px;
        display: inline-block;
        b {
          color: #d11a2e;
          font-style: normal;
          border-radius: 30px;
          border: 1px solid #d11a2e;
          display: inline-block;
          font-weight: normal;
          padding: 0 3px;
          margin: 0 3px;
          font-size: 12px;
          line-height: 16px;
        }
      }
      .dateText {
        color: #666;
        float: left;
        font-size: 14px;
        width: auto;
      }
      .text {
        float: right;
      }
    }
    p.text {
      height: 56px;
      overflow: hidden;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      margin: 5px 10px 10px;
      padding: 0;
      text-align: left;
      font-weight: bold;
    }
  }
  .newList:hover {
    background: #f2f2f2;
    .newListImg img {
      transform: scale(1.2);
      transition: all 3s;
    }
  }
  .more {
    padding: 10px 50px;
    color: #d11a2e;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
    margin-bottom: 50px;
    margin-top: 20px;
  }
  .more:hover {
    background: #f7f7f7;
    border: 1px solid #dcdfe6;
  }
  .el-button:hover {
    border: 1px solid #eee;
    color: #d11a2e;
  }
  .el-button:focus {
    color: #d11a2e;
    border-color: #ccc;
    background-color: #f7f7f7;
  }
  @media (max-width: 768px) {
    .newList {
      p.title {
        span.text {
          display: none;
          float: left;
        }
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .newList {
      p.title {
        .dateText {
          width: auto;
          float: left;
        }
      }
      p.text {
        font-weight: normal;
      }
      .newListImg {
        height: 132px;
      }
    }
  }
  @media (min-width: 1024px) and (max-width: 1200px) {
    .newList {
      p.title {
        .dateText {
          float: left;
          width: auto;
        }
      }
      p.text {
        font-weight: normal;
      }
      .newListImg {
        height: 152px;
      }
    }
  }
  @media only screen and (min-width: 1200px) {
    .newList {
      p.title {
        font-weight: normal;
        .dateText {
          float: left;
          width: auto;
        }
      }
      p.text {
        font-weight: normal;
      }
      .newListImg {
        height: 172px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch10.vue